/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdminServiceUpdateProdAltArtRequest } from '../../models/admin-service-update-prod-alt-art-request';
import { UpdateProdAltArtResponse } from '../../models/update-prod-alt-art-response';

export interface AdminServiceUpdateProdAltArt$Params {
  gachaId: string;
  altArtId: number;
      body: AdminServiceUpdateProdAltArtRequest
}

export function adminServiceUpdateProdAltArt(http: HttpClient, rootUrl: string, params: AdminServiceUpdateProdAltArt$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProdAltArtResponse>> {
  const rb = new RequestBuilder(rootUrl, adminServiceUpdateProdAltArt.PATH, 'put');
  if (params) {
    rb.path('gachaId', params.gachaId, {});
    rb.path('altArtId', params.altArtId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateProdAltArtResponse>;
    })
  );
}

adminServiceUpdateProdAltArt.PATH = '/api/v3/gateway/admin/alt_art/{gachaId}/{altArtId}';
